// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__2s+jh"};